import Form from '@ks/mobile-general-form/src/form';
export default Form;
